import React, { useState, useEffect } from 'react';
import { Box, IconButton } from '@material-ui/core';
import { DoubleChevronIcon } from '../../config/svg/GlobalSvg';
import UserNavigation from './UserNavigation';
import '../../styles/layout/sidebar.scss';

// Below 1024px the app already shows a full-screen "unsupported viewport" overlay
// (_screenlockMessage.scss), so that range is unreachable and intentionally unhandled here.
const AUTO_COLLAPSE_QUERY = '(max-width: 1279px)';

export default function Sidebar(props) {
	const [collapsed, setCollapsed] = useState(false);

	useEffect(() => {
		if (window.matchMedia && window.matchMedia(AUTO_COLLAPSE_QUERY).matches) {
			setCollapsed(true);
		}
	}, []);

	useEffect(() => {
		document.body.classList.toggle('sidebar-collapsed', collapsed);
	}, [collapsed]);

	useEffect(() => {
		return () => document.body.classList.remove('sidebar-collapsed');
	}, []);

	const toggleSidebar = () => setCollapsed((prev) => !prev);

	return (
		<Box component='aside' className='app-sidebar' aria-label='Sidebar navigation'>
			<Box className='sidebar-toggle-wrap'>
				<IconButton
					className={`sidebar-toggle-btn${collapsed ? ' is-collapsed' : ''}`}
					onClick={toggleSidebar}
					aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
					title={collapsed ? 'Expand navigation' : 'Collapse navigation'}
				>
					<DoubleChevronIcon />
				</IconButton>
			</Box>
			<nav className='sidebar-nav' aria-label='Main'>
				<UserNavigation {...props} />
			</nav>
		</Box>
	);
}
